window.StatementHandler = Backbone.Model.extend({

    initialize: function(params) {
        this.container = params.container
        this.name = params.name;
        this.agent = params.agent;

        this.loadStatement(params.path);
        this.initializeData();
        this.setupListeners();
    },

    initializeData: function() {
        this.data = [];
    },

    setAgent: function(data) {
		data.learnerName = this.agent.name;
        data.learnerId = this.agent.id;
        data.lmsHome = this.agent.lms;
		// Logger.info("StatementHandler.setAgent", data)
    },

    addDataItem: function(item) {
        this.data.push(item);
    },

    loadStatement: function(path) {
        $.ajax(path, {
            dataType: "text"
        })
        .done(this.handleStatementLoaded.bind(this))
        .fail(function() {
            Logger.error(this.name + ": failed to load statement");
        }.bind(this));
    },

    handleStatementLoaded: function(statement) {
        this.statement = statement;
    },

    setupListeners: function() {
        this.listenTo(this.container.screenManager, "onBlockInitialized", this.handleBlockInitialized);
    },

    handleBlockInitialized: function(e) {
        if(e.blockData.view instanceof Junction) this.handleJunction(e.blockData.view);

        this.listenToOnce(e.blockData.view, "onDestroy", function() {
            if(e.blockData.view) this.stopListening(e.blockData.view);
        });
    },

    handleJunction: function(junction) {
        this.listenToOnce(junction, "onJunctionDataCreated", function() {
            this.listenTo(junction.gameController, "onSwitchChange", this.handleChangeSlide);
            this.listenTo(junction.gameController.pageRenderer, "onBlockInitialized", this.handleBlockInitialized);
        });

        this.listenToOnce(junction, "onDestroy", function() {
            this.stopListening(junction.gameController, "onSwitchChange");
            this.stopListening(junction.gameController.pageRenderer, "onBlockInitialized");

        });
    },

    prepareStatements: function() {
        var stataments = _.map(this.data, function(item) {
            this.setAgent(item);
            return this.substituteData(item);
        }, this);

        return stataments;
    },

    substituteData: function(data) {
        var statement = this.statement;

        _.each(data, function(value, label) {
            if(typeof value === "string"){
                value = value.replace(/\n/g, "\\n").replace(/\r/g, "\\r"); // escape new line characters
            }
            statement = statement.replace(new RegExp("%%" + label + "%%", "g"), value);
        });
        Logger.info("StatementHandler.substituteData", statement)
        return JSON.parse(statement);
    },
	
    ready: function() {
		var statements = this.prepareStatements();

        Logger.info("StatementHandler.ready", statements);

        this.trigger("onReady", {statements: statements});
        this.initializeData(); // reset
    }
});
